import { useContext } from 'react';
import { CompanyContext, CompanyContextData } from './context';

export function useCompanyContext(): CompanyContextData {
    const data = useContext<CompanyContextData | undefined>(CompanyContext);

    if (!data) {
        throw new Error(
            "CompanyContext unavailable. Are you sure you're using this in a nested component of an CompanyContextProvider?"
        );
    }

    return data;
}
